import { Box } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import { Theme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import LooksOneIcon from '@material-ui/icons/LooksOne';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import EditorButton from 'Components/Common/Buttons/EditorButton';
import ReportExportWizard from 'Components/Common/ReportExportWizard';
import { PlayMode, UseVideoPlayerInstance } from 'Hooks/Editor/useVideoPlayerInstance';
import { ReactElement, useState } from 'react';

interface PlayerUtilityControlsProps {
	instance: UseVideoPlayerInstance;
}

const useStyles = makeStyles(({ spacing }: Theme) => ({
	formGroup: {
		'& > div': {
			marginBottom: spacing(1),
		},
		'& > div:last-child': {
			marginBottom: 0,
		},
	},
	root: {
		display: 'inline-block',
	},
}));

const PlayerUtilityControls = ({ instance }: PlayerUtilityControlsProps): ReactElement => {
	const [isExportModalOpen, setIsExportModalOpen] = useState(false);

	const classes = useStyles();

	const handlePlayModeChanged = (): void => {
		instance.togglePlayMode();
	};

	const handleVisibleFiltersButtonClick = (): void => {
		instance.toggleShowFilteredDetections();
	};

	const handleExportExcelReportButtonClick = (): void => {
		setIsExportModalOpen(true);
	};

	const handleCloseExportModal = (): void => {
		setIsExportModalOpen(false);
	};

	return (
		<>
			<Box border={1} className={classes.root}>
				<FormControl className={classes.formGroup}>
					<EditorButton
						title={instance.playMode === PlayMode.NORMAL ? 'Set play mode to 1 second' : 'Set play mode to normal'}
						onClick={handlePlayModeChanged}
						hotkey="m"
						disabled={instance.isFiltering}
					>
						{instance.playMode === PlayMode.NORMAL ? <AvTimerIcon /> : <LooksOneIcon />}
					</EditorButton>

					<EditorButton
						title={instance.showFilteredDetections ? 'Hide excluded detections' : 'Show excluded detections'}
						onClick={handleVisibleFiltersButtonClick}
						hotkey="v"
						disabled={instance.isFiltering}
					>
						{instance.showFilteredDetections ? <VisibilityIcon /> : <VisibilityOffIcon />}
					</EditorButton>

					<EditorButton
						title="Export Excel Report"
						disabled={instance.isFiltering}
						onClick={handleExportExcelReportButtonClick}
					>
						<VerticalAlignBottomIcon />
					</EditorButton>
				</FormControl>
			</Box>

			{!!instance.video && (
				<ReportExportWizard
					isOpen={isExportModalOpen}
					onClose={handleCloseExportModal}
					placements={instance.placements}
					brandGroups={instance.brandGroups}
					selectedVideoIds={[instance.video?.id ?? 0]}
					videos={[instance.video]}
				/>
			)}
		</>
	);
};

export default PlayerUtilityControls;
